import { ItemState } from './reducers'
import Source from './data/McDonald_201906.json'

let itemId = 1;
export default function generateList() {
    const list = new Array<ItemState>();
    Source.forEach(item => {
        list.push({id: itemId++, name: item.name, selecetd: false, nutrients: item.nutrients});
    });
    return list;
}